export const PRINT_SHIPPING = 'PRINT_SHIPPING';
export const PRINTS_SHIPPING = 'PRINTS_SHIPPING';
export const PRINT_ORDER = 'PRINT_ORDER';
export const PRINTS_ORDER = 'PRINTS_ORDER';